import { render, staticRenderFns } from "./404.vue?vue&type=template&id=3a5c70d3&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5c70d3')) {
      api.createRecord('3a5c70d3', component.options)
    } else {
      api.reload('3a5c70d3', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=3a5c70d3&", function () {
      api.rerender('3a5c70d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/errors/404.vue"
export default component.exports